import React from 'react';
import { PetYearThrowback } from './components/PetYearThrowback';
export function App() {
  return <div className="w-full min-h-screen bg-gray-50" data-id="element-0">
      <PetYearThrowback data-id="element-1" />
    </div>;
}